import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import { jiudianData } from "@/mocks/categoryData";
import { useState } from "react";

export default function JiudianPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[70vh] flex items-center pt-20 pb-16">
          <div className="absolute inset-0">
            <img
              src={jiudianData.heroImage}
              alt={jiudianData.title}
              className="w-full h-full object-cover object-top"
              title={jiudianData.title}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 pt-12">
            <div className="max-w-6xl mx-auto">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-500 text-foreground-950 text-xs font-semibold mb-4">
                独家内幕
              </span>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
                {jiudianData.title}
              </h1>
              <p className="mt-3 text-lg md:text-2xl font-heading text-background-300">
                {jiudianData.subtitle}
              </p>
              <p className="mt-4 text-sm md:text-base text-background-200/80 max-w-xl">
                {jiudianData.description}
              </p>
            </div>
          </div>
        </section>

        {/* Featured article */}
        <section className="w-full -mt-20 relative z-20 pb-16 md:pb-24">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
                <div className="flex flex-col lg:flex-row">
                  <div className="lg:w-[40%] h-[300px] md:h-[400px] lg:h-auto relative overflow-hidden">
                    <img
                      src={jiudianData.featuredArticle.image}
                      alt={jiudianData.featuredArticle.title}
                      className="w-full h-full object-cover object-top"
                      title={jiudianData.featuredArticle.title}
                    />
                    <div className="absolute top-4 left-4">
                      <span className="inline-block px-3 py-1 rounded-full bg-secondary-500 text-foreground-950 text-xs font-semibold">
                        爆炸头条
                      </span>
                    </div>
                  </div>
                  <div className="lg:w-[60%] p-6 md:p-8 lg:p-10 flex flex-col justify-center">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="w-2 h-2 rounded-full bg-secondary-400 animate-pulse"></span>
                      <span className="text-xs text-secondary-600 font-medium">{jiudianData.featuredArticle.time}</span>
                    </div>
                    <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight">
                      {jiudianData.featuredArticle.title}
                    </h2>
                    <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                      {jiudianData.featuredArticle.excerpt}
                    </p>
                    <Link
                      to="/content/jiudian/detail/jd-1"
                      className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-secondary-600 hover:text-secondary-700 transition-colors cursor-pointer"
                    >
                      阅读全文
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Article list */}
        <section className="w-full bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                  更多酒店猛料<span className="text-secondary-500">每日更新</span>
                </h2>
                <span className="text-xs text-foreground-500">{jiudianData.articles.length}条爆料</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {jiudianData.articles.map((a, i) => (
                  <Link
                    key={a.id}
                    to={`/content/jiudian/detail/${a.id}`}
                    className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-colors cursor-pointer"
                  >
                    <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-200 w-10 flex-shrink-0 text-center">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-secondary-500 transition-colors line-clamp-2">
                        {a.title}
                      </h3>
                      <div className="flex items-center gap-3 mt-1.5">
                        <span className="text-xs text-foreground-500">{a.time}</span>
                        <span className="text-xs text-foreground-400">{a.views} 次围观</span>
                      </div>
                    </div>
                    <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-secondary-500 transition-colors flex-shrink-0"></i>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <CategoryCTA color="secondary" />
      </main>

      <Footer />
    </div>
  );
}

function CategoryCTA({ color }: { color: string }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = form.querySelector<HTMLInputElement>(".hn-field");
    if (honeypot && honeypot.value.trim() !== "") {
      setStatus("success"); setStatusMsg("订阅成功！"); setEmail(""); return;
    }
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const fd = new URLSearchParams();
      fd.append("email", email); fd.append("source", `cat_${color}_newsletter`);
      await fetch("https://readdy.ai/api/form/d90hoh84jh3v1cgksmbg", {
        method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: fd.toString(),
      });
      setStatus("success"); setStatusMsg("订阅成功！更多酒店猛料即将送达。"); setEmail("");
    } catch { setStatus("error"); setStatusMsg("网络异常，请稍后重试"); }
  };

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20and%20deep%20dark%20abstract%20gradient%2C%20soft%20glowing%20effect%2C%20cinematic%20mood&width=1920&height=600&seq=cat-cta-secondary-01&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50">不想错过酒店猛料？</h2>
        <p className="mt-3 text-sm md:text-base text-background-300">订阅后第一时间获取独家内幕推送</p>
        <form onSubmit={handleSubmit} data-readdy-form className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
          <input type="text" name="company_alt" className="hn-field" tabIndex={-1} autoComplete="off" aria-hidden="true" />
          <input type="email" name="email" value={email} onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }} placeholder="输入邮箱订阅" className="flex-1 w-full sm:w-auto px-5 py-3 rounded-full bg-background-50/10 border border-background-300/30 text-background-50 text-sm placeholder-foreground-500 outline-none focus:border-accent-400 transition-colors" required />
          <button type="submit" disabled={status === "loading"} className="px-6 py-3 rounded-full bg-secondary-500 text-foreground-950 text-sm font-semibold whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer disabled:opacity-50">
            {status === "loading" ? <i className="ri-loader-4-line animate-spin"></i> : "立即订阅"}
          </button>
        </form>
        {status !== "idle" && <p className={`mt-3 text-sm ${status === "success" ? "text-accent-400" : "text-primary-400"}`}>{statusMsg}</p>}
      </div>
    </section>
  );
}